// eslint-disable-next-line import/prefer-default-export
export const MODIFIER_DATES = {
  title: 'Modification date de début et de fin',
  dateDebut: 'Date de début',
  dateFin: 'Date de fin',
  cancel: 'Annuler',
  apply: 'Appliquer',
  error: {
    title: 'Modification impossible',
    dateDebutSuperieure: 'La date de début est supérieure à la date de fin.',
    aucuneLigneValide: 'Aucune ligne séléctionnée ne peut être modifiée. Les modifications de dates ne se font que sur les faces, réseau LC, écran numérique et réseau numérique.',
    aucuneValeur: 'Aucune date séléctionnée.',
  },
  info: {
    title: 'Informations',
    reseauNonValidePluriel: 'Les modifications de dates ne se font que sur les faces, réseau LC, écran numérique et réseau numérique. Des séléctions ne sont pas valides et ne seront pas prises en compte :',
    reseauNonValide: 'Les modifications de dates ne se font que sur les faces, réseau LC, écran numérique et réseau numérique. Une séléction n\'est pas valide et ne sera pas prise en compte :',
    dateDebutBloqueePluriel: 'Impossible de modifier la date de début car des lignes de commande ont déjà une affectation logistique :',
    dateDebutBloquee: 'Impossible de modifier la date de début car une ligne de commande a déjà une affectation logistique :',
  },
};
